import { Route } from 'react-router-dom';

import StandaloneChatPage from '$app-web/modules/standalone-chat';

const StandaloneSpaceContainer = () => <Route exact path="/standalone/chat" component={StandaloneChatPage} />;

export default StandaloneSpaceContainer;
